import { JsonFormsDispatch } from "@jsonforms/react";
import { css } from "@emotion/css";
import { ItemProps } from "../types";
import { findUISchema } from "@jsonforms/core";
import { ItemHeading } from "../ItemHeading";

export function BaseSummary(props: ItemProps) {
  const schema = findUISchema(
    props.uischemas || [],
    props.schema,
    props.uischema.scope,
    props.path,
    undefined,
    props.uischema,
    props.rootSchema
  );

  return (
    <>
      <div className={styles.elementHeading}>
        <ItemHeading {...props} />
      </div>
      <JsonFormsDispatch
        schema={props.schema}
        uischema={schema}
        path={props.path}
      />
    </>
  );
}

const styles = {
  elementHeading: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }),
};
